import { useEffect, useState } from 'react';
// @mui
import {
  Box,
  Stack,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
// hooks
import useResponsive from "../../../hooks/useResponsive"

// ----------------------------------------------------------------------

export default function FliersProfileReasonDialog({ isOpen, closeDialog, origCasualChat, setOrigCasualChat, origPartTime, setOrigPartTime, origMiniProject, setOrigMiniProject }) {
  const smUp = useResponsive('up', 'sm');
  const [needCasualChat, setNeedCasualChat] = useState(origCasualChat);
  const [needPartTime, setNeedPartTime] = useState(origPartTime);
  const [needMiniProject, setNeedMiniProject] = useState(origMiniProject);

  const updateAndClose = () => {
    setOrigCasualChat(needCasualChat);
    setOrigPartTime(needPartTime);
    setOrigMiniProject(needMiniProject);
    closeDialog();
  }

  useEffect(() => {
    if (isOpen) {
      setNeedCasualChat(origCasualChat);
      setNeedPartTime(origPartTime);
      setNeedMiniProject(origMiniProject);
    }
  }, [isOpen]);
 
  return (
    <Dialog open={isOpen} maxWidth="sm" onClose={closeDialog} fullWidth fullScreen={!smUp}>
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" sx={{ mb: { xs: 3, sm: 5 } }}>
          크루와 커피챗 하고 싶은 이유를 모두 선택해주세요.
        </Typography>
        <Typography variant="h6" sx={{ color: "info.main" }} paragraph>
          커피챗 목적 선택하기
        </Typography>
        {/* reason 1 */}
        <Stack direction="row" alignItems="center"
          sx={{
            width: 1,
            background: (theme) => needCasualChat && theme.palette.grey[200],
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: '#919EAB52',
            },
            borderRadius: 1,
            border: '1px solid #919EAB52',
            py: 1,
            px: 0.5,
          }}
          onClick={(e) => {e.stopPropagation(); setNeedCasualChat(!needCasualChat)}}
        >
          <Checkbox
            checked={needCasualChat}
            onClick={(e) => {e.stopPropagation(); setNeedCasualChat(!needCasualChat)}}
          />
          <Box sx={{ p: 0, m: 0 }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={0}>
              <Typography variant="subtitle2" sx={{ wordBreak: 'break-all' }}>
                캐주얼 커피챗 :&nbsp;
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                회사와 관련한 가벼운 이야기 나눠보고 싶어요.
              </Typography>
            </Stack>
          </Box>
        </Stack>

        {/* reason 2 */}
        <Stack direction="row" alignItems="center"
          sx={{
            mt: 1,
            width: 1,
            background: (theme) => needPartTime && theme.palette.grey[200],
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: '#919EAB52',
            },
            borderRadius: 1,
            border: '1px solid #919EAB52',
            py: 1,
            px: 0.5,
          }}
          onClick={(e) => {e.stopPropagation(); setNeedPartTime(!needPartTime)}}
        >
          <Checkbox
            checked={needPartTime}
            onClick={(e) => {e.stopPropagation(); setNeedPartTime(!needPartTime)}}
          />
          <Box sx={{ p: 0, m: 0 }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={0}>
              <Typography variant="subtitle2" sx={{ wordBreak: 'break-all' }}>
                파트타임 진행 :&nbsp;
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                파트타임으로 업무를 진행해보고 싶어요.
              </Typography>
            </Stack>
          </Box>
        </Stack>

        {/* reason 3 */}
        <Stack direction="row" alignItems="center"
          sx={{
            mt: 1,
            width: 1,
            background: (theme) => needMiniProject && theme.palette.grey[200],
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: '#919EAB52',
            },
            borderRadius: 1,
            border: '1px solid #919EAB52',
            py: 1,
            px: 0.5,
          }}
          onClick={(e) => {e.stopPropagation(); setNeedMiniProject(!needMiniProject)}}
        >
          <Checkbox
            checked={needMiniProject}
            onClick={(e) => {e.stopPropagation(); setNeedMiniProject(!needMiniProject)}}
          />
          <Box sx={{ p: 0, m: 0 }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={0}>
              <Typography variant="subtitle2" sx={{ wordBreak: 'break-all' }}>
                미니 프로젝트 진행 :&nbsp;
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                채용 제안 전, 2주 동안 미니 프로젝트를 진행해보고 싶어요.
              </Typography>
            </Stack>
          </Box>
        </Stack>
        
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          size="large"
          variant="text"
          sx={{ px: 6 }}
          onClick={closeDialog}
        >
          닫기
        </Button>
        <Button
          size="large"
          variant="contained"
          sx={{ px: 6 }}
          onClick={updateAndClose}
        >
          선택완료
        </Button>
      </DialogActions>
    </Dialog>
  )
}